export default "__VITE_ASSET__ef813014__"